export function roundFloat(n: number, scale: number): number {
    return Number.parseFloat(n.toFixed(scale))
}
